document.querySelectorAll('a[href*="#"]').forEach(a => {
  a.addEventListener('click', function(e) {
    const id = this.hash.slice(1);
    const el = document.getElementById(id);
    if (el) {
      e.preventDefault();
      // Drawer schließen
      Alpine.store('modals').leftDrawer.open = false;
      Alpine.store('modals').leftDrawer.contents = '';
      
      setTimeout(() => {
        el.scrollIntoView({ behavior: 'smooth' });
      }, 400);
    }
  });
});